import { render, staticRenderFns } from "./crud_salary_component.vue?vue&type=template&id=d793efa6&scoped=true"
import script from "./crud_salary_component.vue?vue&type=script&lang=js"
export * from "./crud_salary_component.vue?vue&type=script&lang=js"
import style0 from "./crud_salary_component.vue?vue&type=style&index=0&id=d793efa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d793efa6",
  null
  
)

export default component.exports